module.exports = __webpack_public_path__ + "static/index/img/baikal-706.630fa3eb.jpg";